export type UserRole = 'admin' | 'user' | 'timed' | 'viewer';

export interface UserProfile {
  uid: string;
  role: UserRole;
  enabledFeatures: string[];
  expiresAt?: number; // epoch ms
  disabled?: boolean;
}

export function isExpired(expiresAt?: number, now = Date.now()): boolean {
  return typeof expiresAt === 'number' && expiresAt > 0 && expiresAt <= now;
}
